import javascript from '../../assets/stacklogo/javascript.svg';

export default function Javascript(){
    return(
        <img src={javascript} alt="" srcset="" />
    )
}